import { OMPCoreLayoutConstantS } from '../Constant/module/OMPCoreLayoutConstantS.js';
import { find, go, html, map, reject, sel, sortBy, strMap } from 'fxjs/es';
import { OMPCoreAtomTmplS } from '../../../Atom/S/Tmpl/module/OMPCoreAtomTmplS.js';
import { OMPCoreLayoutNavigationTmplS } from '../../Navigation/S/Tmpl/module/OMPCoreLayoutNavigationTmplS.js';
import { SubInteractiveMenuMo } from '../../../../../../services/Marpple/client/widgets/sub-menu/sub-interactive-menu/sub-interactive-menu-mo.ts';
import { hamMenuLoginHTML } from './header.js';
import { UtilS } from '../../../../../Util/S/Function/module/UtilS.js';

const IMAGE_PATHS = {
  main: '//s3.marpple.co/files/u_5306914/2025/8/original/fb691d87ed8155137a6e98c2d00845bc78a9ec353.png',
  biz: '//s3.marpple.co/files/u_5306914/2025/8/original/6a3420c908c59ba450f11dd9cc0ab31ac5c64de42.png',
  kit: '//s3.marpple.co/files/u_5306914/2025/8/original/bb8e3696f60682ff9b024fecfde675e4f26e53861.png',
  ip: '//s3.marpple.co/files/u_5306914/2025/8/original/dc731ce9be9e1352e3ae79475a0350add64d896d5.png',
  knowHow: '//s3.marpple.co/files/u_5306914/2025/8/original/ac7c6689094c8307eb0e8cac8ee681f0c3d688874.png',
};

const langs = ['kr', 'en', 'jp'];

const hamMenusHTML = ({ login_user, ham_menus, wish_count, cart_count, mp_navigations }) => {
  const ham_menu = OMPCoreLayoutConstantS.HAM_MENU();
  const active_cate_list = find((cate_list) => cate_list.active, ham_menus) || ham_menus[0];
  if (active_cate_list) {
    active_cate_list.active = true;
  }

  const tt_live_chat = TT('omp_layout::left::sub_03');
  const tt_customer_center = TT('omp_layout::left::sub_04');
  const tt_about = TT('omp_layout::left::sub_05');

  const ham_header_menu = [
    {
      type: 'main',
      title: ham_menu.make_product.title,
      href: `/${TT.lang}/`,
      thumbnail: IMAGE_PATHS.main,
      render_condition: () => true,
    },
    {
      type: 'biz',
      title: ham_menu.group_biz_products.title,
      href: `/${TT.lang}/${ham_menu.group_biz_products.url}`,
      thumbnail: IMAGE_PATHS.biz,
      render_condition: () => true,
    },
    {
      type: 'kit',
      title: ham_menu.corp_goods?.title || '',
      href: `/${TT.lang}/${ham_menu.corp_goods?.url || ''}`,
      thumbnail: IMAGE_PATHS.kit,
      render_condition: () => !!ham_menu.corp_goods,
    },
    {
      type: 'ip',
      title: ham_menu.portfolio.title,
      href: `/${TT.lang}/${ham_menu.portfolio.url}`,
      thumbnail: IMAGE_PATHS.ip,
      render_condition: () => TT.lang === 'kr',
    },
    {
      type: 'knowHow',
      title: ham_menu.know_how?.title || '',
      href: `/${TT.lang}/${ham_menu.know_how?.url || ''}`,
      thumbnail: IMAGE_PATHS.knowHow,
      render_condition: () => !!ham_menu.know_how,
    },
  ];

  const renderHamHeaderMenu = go(
    ham_header_menu,
    map((menu) => (menu.render_condition() ? menu : null)),
    sortBy((a, b) => {
      if (a === null && b !== null) return 1; // a는 뒤로
      if (a !== null && b === null) return -1; // a는 앞으로
      return 0; // 순서 유지
    }),
    strMap((menu) => {
      if (!menu) return '<li class="mp-header-ham__menus-li"></li>';
      const { type, title, href, thumbnail } = menu;
      return html`
        <li class="mp-header-ham__menus-li">
          <a href="${href}">
            <img class="mp-header-ham__menus-li__thumbnail" src="${thumbnail}" alt="${type}" />
            <span class="mp-header-ham__menus-li__txt">${title}</span>
          </a>
        </li>
      `;
    }),
  );

  return html`
    <div class="mp-header-ham" id="ham">
      <div class="mp-header-ham__top">
        <div class="mp-header-ham__product-list-title">
          <h2 class="mp-header-ham__product-list-title-h2">
            <a href="/${TT.lang}"
              ><img
                src="//s3.marpple.co/files/u_218933/2023/7/original/9c422462100a76c3b568e50a1faade32c9bf1c661.svg"
                alt="MARPPLE"
            /></a>
          </h2>
        </div>
        <div class="mp-header-ham__top-right">
          <div class="mp-header-mo__wish wish not_sell_family" data-count="${wish_count}">
            ${OMPCoreAtomTmplS.heartButtonLink({
              badge: wish_count,
              link: `/${TT.lang}/wish/list`,
              active: false,
            })}
          </div>
          <div class="mp-header-mo__cart cart not_sell_family" data-count="${cart_count}">
            ${OMPCoreAtomTmplS.cartButtonLink({ badge: cart_count, link: `/${TT.lang}/cart` })}
          </div>
        </div>
        <div class="mp-header-ham__menus">
          <ul class="mp-header-ham__menus-ul">
            ${renderHamHeaderMenu}
          </ul>
        </div>
        <div id="ham_close">
          <button type="button"></button>
        </div>
      </div>
      <div class="mp-header-ham__bottom">
        <div class="mp-header-ham__bottom-left">
          <div class="mp-header-ham__section mp-header-ham__section--cate-list-area">
            ${strMap(({ id, new_tag = false, active = false, text } = {}) => {
              return html`
                <div class="mp-header-ham__item" data-id="${id}" data-active="${active}">
                  <span class="omp-atom__category-button-text">${text}</span>
                  ${new_tag ? html`<span class="omp-atom__category-button-new-tag"></span>` : ''}
                </div>
              `;
            }, ham_menus)}
          </div>
          <div class="mp-header-ham__section">
            <div class="mp-header-ham__section-login">${hamMenuLoginHTML(login_user)}</div>

            <div class="mp-header-ham__item live_chat">${tt_live_chat}</div>
            <div class="mp-header-ham__item">
              <a
                href="/${TT.lang}/help-center/${TT.lang === 'kr'
                  ? 'order-pay-kr'
                  : TT.lang == 'jp'
                    ? 'order-pay-kr'
                    : 'buying-shipping'}"
              >
                ${tt_customer_center}
              </a>
            </div>

            <div class="mp-header-ham__item">
              <a href="/${TT.lang}/about"> ${tt_about} </a>
            </div>

            <div class="mp-header-ham__item mp-header-ham__lang" data-is_show="false">
              <div class="mp-header-ham__lang-selected">
                <span>${TT.lang.toUpperCase()}</span>
              </div>

              <ul class="mp-header-ham__lang-ul">
                ${go(
                  langs,
                  reject((lang) => lang === TT.lang),
                  strMap((lang) => {
                    return html` <li class="mp-header-ham__lang-li">
                      <a href="/${lang}" class="omp-change-lang" data-lang="${lang}">${lang.toUpperCase()}</a>
                    </li>`;
                  }),
                )}
              </ul>
            </div>
          </div>
        </div>
        <div class="mp-header-ham__bottom-right" data-show_cate_list_id="${active_cate_list?.id}">
          ${OMPCoreLayoutNavigationTmplS.makeNavi({
            cate_list_id: active_cate_list?.id,
            is_mobile: true,
            cate_lists: ham_menus,
            mp_navigations,
            login_user,
          })}
        </div>
      </div>
    </div>
  `;
};

const mobileDefaultHeader = ({ wish_count, cart_count, title, menu_title, is_back }) => {
  const titleHTML = () => {
    if (menu_title) {
      return html`
        <h1 class="mp-header-mo__h1-menu-title" data-show="false">
          <span class="mp-header-mo__h1-menu-title-txt">${menu_title}</span>
          <span class="mp-header-mo__h1-menu-title-arrow"> ${OMPCoreAtomTmplS.triangleIcon2()} </span>
        </h1>
      `;
    } else if (title) {
      return html`<h1 class="mp-header-mo__h1-txt">${title}</h1>`;
    } else {
      return html`
        <h1 class="mp-header-mo__h1">
          <a href="/${TT.lang}/"
            ><img
              src="//s3.marpple.co/files/u_218933/2023/7/original/9c422462100a76c3b568e50a1faade32c9bf1c661.svg"
              alt="MARPPLE"
          /></a>
        </h1>
      `;
    }
  };

  return html`
    <div class="mp-header-mo__top">
      <div class="mp-header-mo__left">
        ${is_back ? html` <div class="mp-header-mo__btn-prev">${OMPCoreAtomTmplS.arrowButton()}</div>` : ''}
        <div class="mp-header-mo__ham-btn" id="ham_button">${OMPCoreAtomTmplS.hamButton()}</div>
      </div>
      <div class="mp-header-mo__center">${titleHTML()}</div>
      <div class="mp-header-mo__right">
        <div class="mp-header-mo__wish wish not_sell_family" data-count="${wish_count}">
          ${OMPCoreAtomTmplS.heartButtonLink({
            badge: wish_count,
            link: `/${TT.lang}/wish/list`,
            active: false,
          })}
        </div>
        <div class="mp-header-mo__cart cart not_sell_family" data-count="${cart_count}">
          ${OMPCoreAtomTmplS.cartButtonLink({ badge: cart_count, link: `/${TT.lang}/cart` })}
        </div>
      </div>
    </div>
  `;
};

/**
 * @param {object} param
 * @param {string?} param.search_value 검색 페이지 검색창 초기값
 */
const mobileSearchHeader = ({ search_value, is_back }) => {
  return html`
    <div class="mp-header-mo__top">
      <div class="mp-header-mo__search-area ${is_back ? 'mp-header-mo__search-area__is-back' : ''}">
        ${is_back ? html` <div class="mp-header-mo__btn-prev">${OMPCoreAtomTmplS.arrowButton()}</div>` : ''}
        <div class="mp-header-mo__search">${headerSearchFormHTML(search_value)}</div>
      </div>
    </div>
  `;
};

/**
 * @param {!string} search_value
 */
const headerSearchFormHTML = (search_value) => {
  return OMPCoreAtomTmplS.searchForm({
    placeholder: TT('search::search_01'),
    value: UtilS.escape(search_value),
    input_klass: 'omp-atom__input-auto-complete', // TODO @kjj `AutoCompleteInput` 으로 랩핑하기
    form_klass: 'omp-search__search-form',
    data: { debounce_time: 300 },
  });
};

/**
 * @param {object} [param = {}]
 * @param {string} param.type
 * @param {object} param.locals
 * @param {string} param.title
 * @param {CateList[] | null} param.sub_menus
 * @param {boolean} [param.is_back]
 * @param {HeaderSearchParam} [locals.search = {}]
 * @param {object[] | null} param.sub_interactive_items
 */
export const mobileHTML = ({
  wish_count,
  cart_count,
  search_value,
  title,
  menu_title,
  sub_menu_all,
  sub_menus,
  sub_interactive_items,
  header_banner,
  policies,
  login_user,
  type,
  is_back,
  ham_menus,
  mp_navigations,
  header_banner_type,
  sub_menu_items,
}) => {
  const headerBannerHTML = () => {
    return '';
    // return header_banner ? html` <div id="top-banner">top banner</div> ` : '';
  };

  const typeHeaderHtml = () => {
    if (type === OMPCoreLayoutConstantS.HEADER_TYPE.search) {
      return mobileSearchHeader({ search_value, is_back });
    } else {
      return mobileDefaultHeader({ wish_count, cart_count, title, menu_title, is_back });
    }
  };

  const subMenusHTML = () => {
    if (!sub_menus?.length) return '';
    return html`
      <div class="mp-sub-menus">
        <ul class="mp-sub-menus__ul">
          ${sub_menu_all
            ? html`<li class="mp-sub-menus__li">${OMPCoreAtomTmplS.headerMenuArrow(sub_menu_all)}</li>`
            : ''}
          ${strMap((menu) => {
            return html` <li class="mp-sub-menus__li">${OMPCoreAtomTmplS.categoryLinkSmall(menu)}</li> `;
          }, sub_menus)}
        </ul>
      </div>
    `;
  };

  const subMenuItemsHTML = () => {
    if (!sub_menu_items?.length) return '';
    const txt_all = TT('omp_layout::sub_menu_all_mo');
    const active_cate_item = find((item) => {
      return item.active;
    }, sub_menu_items);
    return html`
      <div class="mp-sub-menu-items">
        <ul class="mp-sub-menu-items__ul">
          <li class="mp-sub-menu-items__li" data-active="${active_cate_item ? 'false' : 'true'}">
            <a href="/${TT.lang}/product/list/${sel('0.cate_list_id', sub_menu_items)}">${txt_all}</a>
          </li>
          ${strMap((menu) => {
            return html`
              <li class="mp-sub-menu-items__li" data-active="${menu.active}">
                <a href="${menu.link.href}">${menu.text}</a>
              </li>
            `;
          }, sub_menu_items)}
        </ul>
      </div>
    `;
  };

  const subInteractiveMenuHTML = sub_interactive_items
    ? new SubInteractiveMenuMo({ ...sub_interactive_items, className: 'utm_gnb_2' })
    : '';

  return html`
    <div class="omp-header" data-header_banner="${header_banner_type}">
      ${headerBannerHTML()}
      <div class="mp-header-mo-wrapper mobile_v">
        <div class="mp-header-mo">
          ${typeHeaderHtml()}
          <div class="mp-header-mo__cate-lists"></div>
          ${hamMenusHTML({ login_user, ham_menus, wish_count, cart_count, mp_navigations })}
        </div>
      </div>
      <div class="omp-header__all-menus" data-show="false"></div>
      <div class="omp-header__product-list-menus utm_gnb" data-show="false">
        <ul class="omp-header__product-list-menus-ul">
          ${strMap((menu) => {
            const {
              id,
              active = false,
              text,
              link: { href = '', is_new_tab = false },
            } = menu;
            return html`
              <li class="omp-header__product-list-menus-li">
                <a
                  href="${href}"
                  ${is_new_tab ? ' target="_blank"' : ''}
                  ${id ? html`id=${id}` : ''}
                  data-active="${active}"
                >
                  <span class="omp-atom__category-button-text">${text}</span>
                </a>
              </li>
            `;
          }, ham_menus)}
        </ul>
      </div>
    </div>
    ${subMenusHTML()} ${subMenuItemsHTML()}
    ${subInteractiveMenuHTML ? subInteractiveMenuHTML.toHtml(true) : ''}
  `;
};
